import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'urlDetector',
  standalone: true,
})
export class UrlDetectorPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    // Regular expression to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+\.[^\s]+)/gi;

    // Replace URLs with anchor tags
    const replacedText = value.replace(urlRegex, (match) => {
      let url = match;
      if (!match.startsWith('http')) {
        url = 'http://' + match;
      }

      // Extract clean label (optional)
      const displayText = new URL(url).hostname.replace('www.', '');

      return `
      </br><a href="${url}" target="_blank" rel="noopener noreferrer" >
        🔗 ${displayText}
      </a></br>
    `;
    });

    // Bypass security to render HTML
    return this.sanitizer.bypassSecurityTrustHtml(replacedText);
  }
}
